import { RegisterForm } from "@/features/auth/components/register-form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/register")({
  component: RegisterPage,
});

function RegisterPage() {
  return (
    <div
      data-testid="auth-register-page"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <RegisterForm />
    </div>
  );
}
